<template>
  <div>
    <div class="wrapper-x-40">
      <h1>{{$t('admin.views.no_license.text')}}</h1>
    </div>
  </div>
</template>

<script>
export default {
  name: "NoLicense",
};
</script>
